import { render } from "./PageSorular.vue?vue&type=template&id=50d4d5a2&scoped=true"
import script from "./PageSorular.vue?vue&type=script&lang=js"
export * from "./PageSorular.vue?vue&type=script&lang=js"

import "./PageSorular.vue?vue&type=style&index=0&id=50d4d5a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50d4d5a2"

export default script